import React from "react";

import { Fonts } from "@churchofjesuschrist/eden-fonts";
import { Normalize } from "@churchofjesuschrist/eden-normalize";
import { WorkforceFooter } from "@churchofjesuschrist/eden-workforce-footer";
import Helmet from "react-helmet";

import AnalyticsAppContext from "./analytics-app-context";
import AppRoutes from "./app-routes";
import ConfigurationContext from "./configuration-context";
import useApp from "./use-app";
import UserContext from "./user-context";
import Error from "../generic/error/error";
import Layout from "../global-layout/Layout";

const defaultFunction = () => {};


const App = () => {
  const {
    coreStatus,
    navigationStatus,
    navigation,
    setNavigationLoading,
    clearNavigationStatus,
    user,
    alerts,
    onUserAlertDeleted,
    configuration,
    strings,
    language,
    changeLanguage,
    requestLanguageGroups = defaultFunction,
    permissions,
    onImpersonationChange,
    requestPermissions,
    warned,
    warnedOn,
    warnedOff,
    printOn,
    printMode = false,
    analyticsPageEvent
  } = useApp({});
  const showCoreError = !coreStatus?.saving && Boolean(coreStatus?.error);
  const showNavigationError = !coreStatus?.saving
    && !navigationStatus?.saving
    && Boolean(navigationStatus?.error);
  const showAppError = showCoreError || showNavigationError;
  const ready = !showAppError && !coreStatus.saving && user;

  //TODO: this is solved for help center.  We want to also know if we should go into a warned navigation
  //or not.
  const {noNav:lean} = navigation;

  return (
    <>
      <Helmet>
        <Fonts />
        <Normalize />

      </Helmet>
      {showAppError && <Error noStrings={true}/>}
      {ready && (<>
        <AnalyticsAppContext.Provider value = {analyticsPageEvent}>
          <UserContext.Provider value={user}>
            <ConfigurationContext.Provider value={configuration}>
              <Layout navigation={navigation}
                lean = {lean}
                printMode = {printMode}
                strings={strings}
                language={language}
                warned={warned}
                user={user}
                userAlerts={alerts}
                onUserAlertDeleted={onUserAlertDeleted}
                changeLanguage={changeLanguage}
                setNavigationLoading={setNavigationLoading}
                clearNavigationStatus={clearNavigationStatus}
                navigationStatus = {navigationStatus}
                confirmedPermissions={permissions}
                onImpersonationChange={onImpersonationChange}>
                <AppRoutes
                  requestLanguageGroups={requestLanguageGroups}
                  requestPermissions={requestPermissions}
                  alerts={alerts}
                  warnedOn={warnedOn}
                  warnedOff={warnedOff}
                  analyticsPageEvent={analyticsPageEvent}
                  printOn={printOn}
                  suppressNotFound={navigationStatus?.saving} />

              </Layout>
            </ConfigurationContext.Provider>
          </UserContext.Provider>
        </AnalyticsAppContext.Provider>
        {!printMode && <WorkforceFooter lang={language}/>}
      </>
      )}

    </>
  );}

export default App;
